import { render, staticRenderFns } from "./PageIntegrations.vue?vue&type=template&id=021c760b&scoped=true&"
import script from "./PageIntegrations.vue?vue&type=script&lang=js&"
export * from "./PageIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./PageIntegrations.vue?vue&type=style&index=0&id=021c760b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c760b",
  null
  
)

export default component.exports